<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4>
          <v-form data-vv-scope="create">
            <v-layout align-center justify-center>
              <v-combobox
                class="width-300 text-xs-left"
                name="orderEmisionType"
                v-validate="'required'"
                :error-messages="errors.collect('create.orderEmisionType')"
                v-model="orderEmisionType"
                :items="orderEmissionTypes"
                flat
                item-text="title"
                :allow-overflow="false"
                type="button"
                single-line
                return-object
              >
                <template slot="selection" slot-scope="data">
                  <div>
                    <span style="color:#005cae">{{data.item.title}}</span>
                  </div>
                </template>
              </v-combobox>
              <v-btn small @click="openDialog()" color="accent">{{$t('message.create')}}</v-btn>
              
            </v-layout>
            <confirm-dialog
            ref="confirmDialog"
            :heading="typeof orderEmisionType!='undefined'?orderEmisionType.title :''"
            :message="$t('message.messageLocation')+' '+(agencyName||0)+' '+$t('message.confirmDialogMessage')"
            @onConfirm="create()"
          ></confirm-dialog>
          </v-form>
        </v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn icon disabled>
          <v-icon>more_vert</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-container fluid>
        <v-layout row wrap align-center justify-center fill-height>
          <v-flex lg6 xs2>
            <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
              <v-icon>cached</v-icon>
            </v-btn>
          </v-flex>
          <v-flex lg6 xs10 text-lg-right>
            <SearchBar
              ref="SearchBar"
              :suggestions="commands"
              placeholder="Para realizar la búsqueda escriba: /"
              v-model="search"
              @clearQuery="clearQuery()"
            ></SearchBar>
            <!--             <v-text-field
              style="padding:0px; margin:0px"
              id="searchBox"
              single-line
              v-model="searchValue"
              @keydown.enter="enter"
              placeholder="Buscar"
              append-icon="search"
              light
              hide-details
            ></v-text-field>-->
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider style="margin:0px"></v-divider>
      <v-card-text style="padding-top:0px">
        <v-data-table
          flat
          item-key="orderId"
          :items="ordersEmissionPaging"
          :pagination.sync="pagination"
          :rows-per-page-items="pagination.rowsPerPageItems"
          :total-items="pagination.totalItems"
          :headers="headers"
          class="v-table-list theme--light"
        >
          <template slot="headers" scope="props">
            <tr class="border-buttom">
              <!-- style="border:1px #d2d5d8 solid" -->
              <th
                v-for="(header,i) in props.headers"
                :key="i"
                :class="['column  text-xs-left', header.sortable ? 'sortable'+ pagination.descending ? ' desc' : ' asc' + header.value === pagination.sortBy ? ' active' : '' :'']"
                @click="changeSort(header)"
              >
                <v-checkbox
                  small
                  :label="header.text+'     '"
                  hide-details
                  v-if="i>1"
                  v-model="filters['t'+(i-1)]"
                  v-on:change="filter()"
                ></v-checkbox>
                <center v-else>
                  <span>{{header.text}}</span>
                </center>
                <v-icon v-if="header.sortable">arrow_upward</v-icon>
              </th>
            </tr>
          </template>
          <template slot="items" scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td class="text-xs-left cut-text">{{ props.item.noOrderEmission }}</td>
              <td style="padding-left:1%" class="text-xs-left cut-text">{{ props.item.clientName }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.cotizationDate) }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.coordinationDate) }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.inspectionDate) }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.emissionDate) }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.fileDeliveryDate) }}</td>
              <td class="text-xs-left cut-text">{{ nzDate(props.item.customerDeliveryDate) }}</td>
            </tr>
          </template>
          <template slot="no-data">
            <div>{{$t('message.noOrderEmissions')}}</div>
          </template>
          <template slot="actions-prepend" class="prepent">
            <v-flex hidden-xs-only>
              <img src="/static/img/Tracking-horizontal.png" alt="site logo" width="150" height="46" style="margin-left:-30px; float: left;">
            </v-flex>
          </template>
          <template
            slot="pageText"
            slot-scope="props"
          >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <BlockDialog v-model="showBlockDialogModal" :textDialog="textDialog" :titleDialog="titleDialog"></BlockDialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";
import ConfirmDialog from "@/components/Widgets/ConfirmDialog";
import { EventBus } from '@/imports/EventBus';
import BlockDialog from "@/components/Dialogs/BlockDialog";

export default {
  components: {
    
    ConfirmDialog,
    BlockDialog
  },
  computed: {
    ...mapGetters(["loadingOrderEmission", "agency","agencyName","userProfile","brokerProfile"]),
    pagination: {
      get: function() {
        return this.$store.getters.paginationOrderEmission;
      },
      set: function(value) {
        this.$store.commit("setPaginationOrderEmission", value);
      }
    },
    ordersEmissionPaging() {
      return this.$store.getters.ordersEmissionPaging;
    }
  },
  mounted() {
    this.orderEmisionType = this.orderEmissionTypes[0];
  },
  watch: {    
    search(val) {
      if (val != "") {
        if (val.length >= 3) {
          let command = null;
          let value = null;
          for (let i = 0; i < this.commands.length; i++) {
            const element = this.commands[i];
            const index = val.indexOf(this.commands[i].langES);
            if (index === 0) {
              let size = this.commands[i].langES.length;
              command = this.commands[i].langEN;
              value = val.slice(size);
              break;
            }
          }
          if (command !== null && value !== null && value !== "") {
            this.filters[command] = value;
          } else if (val.indexOf("/") !== 0 && val !== null && val !== "") {
            this.filters.nombreCliente = val;
          } else {
            let emptySearch = false;
            this.filters.noOrdenEmision = "";
            this.filters.nombreCliente = "";
            if (!emptySearch) {
              return;
            }
          }
          this.querySearch();
        }
      } else {
        this.filters.noOrdenEmision = "";
        this.filters.nombreCliente = "";
        this.querySearch();
      }
    },
    pagination: {
      handler() {
        this.$store
          .dispatch("queryOrderEmission", this.filters)
          .then(result => {});
      },
      deep: true
    },
    loadingOrderEmission(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando información, por favor espere...");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store
        .dispatch("queryOrderEmission", this.filters)
        .then(result => {});
    }
  },
  methods: {
     clearQuery(){
      this.search=""
    },
    nzDate: nzDate,
    create() {
      this.$validator.validateAll("create").then(valid => {
        if (valid) {
          router.push(this.orderEmisionType.url);
        }
      });
    },
  async  openDialog(){

    await  this.InactiveBrokerUserId() ?  this.showBlockDialogModal = true: this.$refs.confirmDialog.openDialog();
    },
   async InactiveBrokerUserId(){
      var isInactive = false;
     await this.$store
        .dispatch("searchBrokerByUserId", this.userProfile.user_id)
        .then(result => {
          if(this.brokerProfile.EstadoBroker == "I"){
            isInactive = true;
          }
          
        });
    
      return isInactive;


    },
    changeSort(column) {
      if (column.sortable == true) {
        if (this.pagination.sortBy === column.header) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column.header;
          this.pagination.descending = false;
        }
      }
    },
    refresh() {
      this.$store
        .dispatch("queryOrderEmission", this.filters)
        .then(result => {});
    },
    enter() {
      this.$store
        .dispatch("queryOrderEmission", this.filters)
        .then(result => {});
    },
    filter() {
      this.$store
        .dispatch("queryOrderEmission", this.filters)
        .then(result => {});
    },
    querySearch() {
      this.$store
        .dispatch("searchOrderEmission", this.filters)
        .then(result => {});
    }
  },
  data() {
    return {     
      showBlockDialogModal: false,
      search: "",
      titleDialog:"Usuario Inactivo",
      textDialog:"Usuario Inactivo, por favor comuniquese con su ejecutivo comercial.",
      commands: [
        { langEN: "noOrdenEmision", langES: "/N° orden " },
        { langEN: "nombreCliente", langES: "/Nombre cliente " }
      ],
      filters: {
        idOrden: "",
        noOrdenEmision: "",
        nombreCliente: "",
        estadoEmision: "",
        t1: false,
        t2: false,
        t3: false,
        t4: false,
        t5: false,
        t6: false,
        requiereInspeccion: false,
        usuarioCreadorId: null,
        usuarioCreadorName: null,
        esPromotor: false,
        identificacion: ""      
      },
      orderEmissionTypes: [
        {
          id: 1,
          title: i18n.t("message.newRiskCar"),
          url: "/orderEmision/vehicleNewRisk"
        },
        {
          id: 2,
          title: i18n.t("message.renovationCar"),
          url: "/orderEmision/vehicleRenovation"
        },
        {
          id: 3,
          title: i18n.t("message.newRiskGeneral"),
          url: "/orderEmision/generalBoardNewRisk"
        },
        {
          id: 4,
          title: i18n.t("message.renovationGeneral"),
          url: "/orderEmision/generalBoardRenovation"
        },
        {
          id: 5,
          title: i18n.t("message.otherMov"),
          url: "/orderEmision/otherMovements"
        }
      ],
      orderEmisionType: undefined,
      searchValue: "",
      headers: [
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.noOrderEmission"),
          value: "noOrderEmission",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.insured"),
          value: "clientName",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListCotizationDate"),
          value: "cotizationDate",
          width: "19%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListCoordinationDate"),
          value: "coordinationDate",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListInspectionDate"),
          value: "inspectionDate",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListEmissionDate"),
          value: "emissionDate",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListFileDeliveryDate"),
          value: "fileDeliveryDate",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.orderEmissionListCustomerDeliveryDate"),
          value: "customerDeliveryDate",
          width: "20%"
        }
      ]
    };
  }
};
</script>
<style >
.theme--light.v-label {
  color: #0a62b1;
  font-size: 12px;
}
.theme-- .v-input--selection-controls__ripple {
  padding: 0px;
  margin: 0px;
}
.v-input--selection-controls__input {
  margin-right: 0px;
}
/* .v-icon{
  font-size: 19px
} */
</style>